<template>

  <PageLayout :page-title="pageTitle" banner-key="service" :show-banner="showTopBanner">



    <div v-if="isFaq" class="queAnsDiv">

      <div class="wrap">

        <div class="hdDiv">

          <div class="nyTitle tc wow fadeInUp"><span class="f48">{{ $t('faq.pageTitle') }}</span></div>

          <div class="telDiv flexcen wow fadeInUp">

            <a :href="'tel:' + hotlineTel" class="flexcen">

              <i class="font_family icon-dianhua"></i>{{ hotline }}

            </a>

          </div>

          <div class="searchDiv wow fadeInUp">

            <form @submit.prevent="onFaqSearch">

              <input v-model="keyword" type="text" :placeholder="$t('faq.searchPlaceholder')">

              <button type="submit"><i class="font_family icon-sousuo"></i></button>

            </form>

          </div>

        </div>

        <div class="bdDiv">

          <div class="listDiv">

            <ul>

              <li v-for="item in faqItems" :key="item.id" :class="{ on: activeId === item.id }">

                <div class="hd flexbet" @click="toggleFaq(item.id)">

                  <div class="title flexbet">

                    <span class="flexcen"><i class="font_family icon-wenti"></i></span>

                    <p>{{ item.title }}</p>

                  </div>

                  <i class="font_family icon-zhankai"></i>

                </div>

                <div v-show="activeId === item.id" class="bd">

                  <div class="flexbet">

                    <span class="flexcen"><i class="font_family icon-daan"></i></span>

                    <div class="p" v-html="item.content"></div>

                  </div>

                </div>

              </li>

            </ul>

            <p v-if="!faqItems.length" class="tishi">{{ $t('common.noContent') }}</p>

          </div>

          <PagePagination :page="pageNum" :total="faqTotal" :page-size="pageSize" @change="onPageChange" />

        </div>

      </div>

    </div>



    <div v-else-if="isValueAdded" class="zezfwDiv">

      <div class="wrap">

        <div class="nyTitle tc wow fadeInUp"><span class="f48">{{ pageTitle }}</span></div>

        <div class="bdDiv">

          <div class="row">

            <div v-for="item in valueItems" :key="item.id" class="col-md-6">

              <router-link :to="item.link || '/contact/'">

                <div class="conDiv flexbet">

                  <div class="iconDiv flexcen"><i class="font_family" :class="item.icon"></i></div>

                  <div class="textDiv">

                    <div class="title">{{ item.title }}</div>

                    <div class="p">{{ item.summary }}</div>

                    <span>{{ $t('common.learnMore') }}<i class="font_family icon-youjiantou"></i></span>

                  </div>

                </div>

              </router-link>

            </div>

          </div>

          <p v-if="!valueItems.length" class="tishi" style="text-align:center;color:#999;padding:48px 0">{{ $t('common.noContent') }}</p>

        </div>

      </div>

    </div>



    <div v-else-if="isProductSupport" class="cpjzDiv">

      <div class="wrap">

        <div class="bdDiv product-support-full">

          <div class="brDiv">

            <div class="rowDiv">

              <div v-if="supportItems.length" class="row">

                <div

                  v-for="item in supportItems"

                  :key="item.id"

                  class="col-md-4 col-sm-6 col-12"

                >

                  <a href="javascript:;" class="imgH" @click.prevent="openSupportItem(item)">

                    <div class="imgDiv imgObj">

                      <div class="pic">

                        <img v-if="itemImage(item)" :src="itemImage(item)" :alt="item.title">

                      </div>

                    </div>

                    <div class="textDiv">

                      <div class="title">{{ item.title }}</div>

                      <p v-if="item.summary" class="support-summary">{{ item.summary }}</p>

                    </div>

                  </a>

                </div>

              </div>

              <p v-else style="text-align:center;color:#999;padding:48px 0">{{ $t('common.noContent') }}</p>

              <PagePagination

                :page="pageNum"

                :total="supportTotal"

                :page-size="pageSize"

                @change="onPageChange"

              />

            </div>

          </div>

        </div>

      </div>

    </div>



    <div v-if="videoPopUrl" class="videoPop" style="display:block" @click.self="closeVideo">

      <div class="popCon">

        <a href="javascript:;" @click.prevent="closeVideo"><i class="font_family icon-guanbi"></i></a>

        <div class="videoDiv">

          <CompatibleVideo
            v-if="videoPopUrl"
            :src="videoPopUrl"
            :controls="true"
            :autoplay="true"
            preload="metadata"
            style="max-width:100%"
          />

        </div>

      </div>

    </div>



    <div v-if="supportPopItem" class="videoPop service-pop" style="display:block" @click.self="closeSupportPop">

      <div class="popCon">

        <a href="javascript:;" @click.prevent="closeSupportPop"><i class="font_family icon-guanbi"></i></a>

        <div class="service-pop__body">

          <h3 class="service-pop__title">{{ supportPopItem.title }}</h3>

          <div class="service-pop__content" v-html="supportPopItem.content"></div>

        </div>

      </div>

    </div>



  </PageLayout>

</template>



<script>

import PageLayout from '@/components/hirays/PageLayout.vue'

import PagePagination from '@/components/hirays/PagePagination.vue'

import CompatibleVideo from '@/components/hirays/CompatibleVideo.vue'

import { listServiceItem, listContactInfo } from '@/utils/http'

import { unwrapRows, resolveImageUrl } from '@/utils/content'

import { fetchSiteNav } from '@/utils/siteNav'

import { SERVICE_NAV_LINKS } from '@/constants/hiraysHomeStatic'

import { SERVICE_VALUE_ITEMS } from '@/constants/hiraysServiceStatic'

import { DEFAULT_PAGE_SIZE, unwrapTotal, scrollToListTop } from '@/utils/pagination'



export default {

  components: { PageLayout, PagePagination, CompatibleVideo },

  props: { serviceSlug: { type: String, default: 'product-support' } },

  data() {

    return {

      faqItems: [],

      serviceNavItems: [],

      supportItems: [],

      supportTotal: 0,

      keyword: '',

      faqSearchKeyword: '',

      pageNum: 1,

      pageSize: DEFAULT_PAGE_SIZE,

      faqTotal: 0,

      activeId: null,

      hotline: '',

      videoPopUrl: '',

      supportPopItem: null,

      valueItems: []

    }

  },

  computed: {

    isFaq() { return this.serviceSlug === 'faq' },

    isValueAdded() { return this.serviceSlug === 'value-added' },

    isProductSupport() { return this.serviceSlug === 'product-support' },

    showTopBanner() { return true },

    hotlineTel() { return this.hotline.replace(/\s/g, '') },

    pageTitle() {

      const item = this.serviceNavItems.find(s => s.slug === this.serviceSlug)

      if (item && item.name) return item.name

      const fallback = SERVICE_NAV_LINKS.find(s => s.slug === this.serviceSlug)

      return fallback ? this.$navLabel('serviceNav', fallback.slug, fallback.name) : this.$t('nav.services')

    }

  },

  watch: {

    serviceSlug() {

      this.resetPageState()

      this.load()

    }

  },

  created() {
    this.loadServiceNav()
    this.loadHotline()
    this.load()
  },

  methods: {

    reloadCmsData() {
      this.loadServiceNav()
      this.loadHotline()
      this.load()
    },

    async loadServiceNav() {
      try {
        const nav = await fetchSiteNav(false, this.$i18n.locale)
        this.serviceNavItems = nav && nav.serviceNav ? nav.serviceNav : []
      } catch (e) {
        this.serviceNavItems = []
      }
    },

    async loadHotline() {
      try {
        const res = await listContactInfo({ type: 0, status: 1, pageNum: 1, pageSize: 1 }, this.$i18n.locale)
        const row = (res.rows || [])[0]
        if (row && row.phone) this.hotline = row.phone
      } catch (e) { /* fallback */ }
    },



    resetPageState() {

      this.pageNum = 1

      this.activeId = null

      this.keyword = ''

      this.faqSearchKeyword = ''

    },

    itemImage(item) {
      return resolveImageUrl(item.picUrl || item.image) || ''
    },



    toggleFaq(id) {

      this.activeId = this.activeId === id ? null : id

    },



    onFaqSearch() {

      this.faqSearchKeyword = this.keyword.trim()

      this.pageNum = 1

      this.activeId = null

      this.loadFaq()

    },



    onPageChange(page) {

      this.pageNum = page

      if (this.isFaq) {

        this.loadFaq()

      } else if (this.isProductSupport) {

        this.loadSupportItems()

      }

      const selector = this.isFaq

        ? '.queAnsDiv .listDiv'

        : '.cpjzDiv .rowDiv'

      scrollToListTop(this.$el.querySelector(selector))

    },



    closeVideo() {

      this.videoPopUrl = ''

    },

    openSupportItem(item) {

      if (item.videoUrl) {

        this.videoPopUrl = resolveImageUrl(item.videoUrl)

        return

      }

      this.supportPopItem = item

    },

    closeSupportPop() {

      this.supportPopItem = null

    },

    mapServiceItemRow(row) {

      const content = row.content || ''

      const summary = this.stripHtml(content)

      return {

        id: row.id,

        title: this.$cleanBrand(row.title || ''),

        content,

        summary: summary.length > 120 ? summary.slice(0, 120) + '...' : summary,

        picUrl: row.picUrl,

        videoUrl: row.videoUrl

      }

    },

    async loadSupportItems() {

      try {

        const params = {

          serviceType: 0,

          status: 1,

          pageNum: this.pageNum,

          pageSize: this.pageSize

        }

        const res = await listServiceItem(params, this.$i18n.locale)

        this.supportItems = unwrapRows(res).map(row => this.mapServiceItemRow(row))

        this.supportTotal = unwrapTotal(res) || this.supportItems.length

      } catch (e) {

        this.supportItems = []

        this.supportTotal = 0

      }

    },



    async load() {

      if (this.isFaq) {

        await this.loadFaq()

      } else if (this.isValueAdded) {

        await this.loadValueItems()

      } else if (this.isProductSupport) {

        await this.loadSupportItems()

      }

    },



    async loadValueItems() {

      try {

        const res = await listServiceItem({ serviceType: 2, status: 1, pageNum: 1, pageSize: 50 }, this.$i18n.locale)

        this.valueItems = unwrapRows(res).map((item, i) => ({

          id: item.id,

          icon: SERVICE_VALUE_ITEMS[i % SERVICE_VALUE_ITEMS.length].icon,

          title: this.$cleanBrand(item.title || ''),

          summary: this.stripHtml(item.content),

          link: '/contact/'

        }))

      } catch (e) {

        this.valueItems = []

      }

    },



    stripHtml(html) {

      if (!html) return ''

      return String(html).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()

    },



    async loadFaq() {

      try {

        const params = { serviceType: 3, status: 1, pageNum: this.pageNum, pageSize: this.pageSize }

        if (this.faqSearchKeyword) params.title = this.faqSearchKeyword

        const res = await listServiceItem(params, this.$i18n.locale)

        this.faqItems = unwrapRows(res)

          .map(row => ({

            id: row.id,

            title: this.$cleanBrand(row.title || ''),

            content: row.content || '',

            sortOrder: row.sortOrder

          }))

          .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))

        this.faqTotal = unwrapTotal(res) || this.faqItems.length

      } catch (e) {

        this.faqItems = []

        this.faqTotal = 0

      }

    }

  }

}

</script>

<style scoped>
.support-summary {
  margin-top: 8px;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}
.service-pop__body {
  padding: 24px 32px 32px;
  max-height: 70vh;
  overflow-y: auto;
  background: #fff;
  border-radius: 8px;
}
.service-pop__title {
  margin: 0 0 16px;
  font-size: 22px;
  color: #333;
}
.service-pop__content {
  color: #666;
  line-height: 1.8;
}
</style>
